/* ControlLoginPage — §11 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/controlApi";
import { Loader2 } from "lucide-react";

export default function ControlLoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email.trim(), password);
      nav("/control", { replace: true });
    } catch (ex) {
      const detail = ex && ex.response && ex.response.data && ex.response.data.detail;
      const msg = (detail && detail.error && detail.error.message) || "Credenciales inválidas.";
      setErr(msg);
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-10 bg-blueblack text-white">
      <form onSubmit={submit} data-testid="spc-login-form" className="w-full max-w-xs space-y-4">
        <div className="text-center mb-6">
          <div className="text-[10px] uppercase tracking-[0.4em] text-slate-400">Sur Primicia</div>
          <div className="font-serif text-3xl font-bold text-white">CONTROL</div>
          <div className="text-[11px] text-slate-400 mt-1">Centro de supervisión operativa</div>
        </div>
        <label className="block">
          <span className="block text-[10px] uppercase tracking-widest text-slate-400 mb-1">Correo</span>
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="spc-login-email"
            className="w-full h-11 px-3 bg-white/5 border border-white/10 text-white text-sm rounded-none focus:outline-none focus:border-white/40" />
        </label>
        <label className="block">
          <span className="block text-[10px] uppercase tracking-widest text-slate-400 mb-1">Contraseña</span>
          <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="spc-login-password"
            className="w-full h-11 px-3 bg-white/5 border border-white/10 text-white text-sm rounded-none focus:outline-none focus:border-white/40" />
        </label>
        {err && <div data-testid="spc-login-error" className="text-xs text-red-400">{err}</div>}
        <button type="submit" disabled={loading} data-testid="spc-login-submit"
          className="w-full h-11 bg-white text-blueblack text-sm uppercase tracking-widest font-bold hover:bg-slate-100 disabled:opacity-50">
          {loading ? <Loader2 className="w-4 h-4 mx-auto animate-spin" /> : "Ingresar"}
        </button>
      </form>
    </div>
  );
}
